import { createApp } from 'vue'
import VisitHistoryReportTable from'../components/reports/VisitHistoryReportTable.vue'

if (document.getElementById('visit-history-report-table')) {
  const visitHistoryReportTable = createApp({})
  visitHistoryReportTable.component('VisitHistoryReportTable', VisitHistoryReportTable)
  visitHistoryReportTable.mount('#visit-history-report-table')
}